/* eslint-disable no-tabs */
import PropTypes from 'prop-types';

const PointerCursorIcon = ({ size = 70 }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={size}
            height={size}
            viewBox="0 0 70.865 70.867"
            enableBackground="new 0 0 70.865 70.867"
            xmlSpace="preserve"
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="#3A3A3A"
                    d="M24.509,37.798c0-0.217,0-0.433,0-0.648
		c0-7.833,0-15.665-0.002-23.494c0-3.119,2.31-5.54,5.316-5.567c3.022-0.025,5.401,2.324,5.435,5.445
		c0.035,3.149,0.01,6.299,0.01,9.447c0,0.245,0,0.489,0,0.746c3.685-0.929,4.916-0.63,7.051,1.706
		c1.454-1.153,3.099-1.604,4.924-1.116c1.834,0.488,3.039,1.695,3.738,3.474c1.078-0.609,2.181-0.919,3.375-0.786
		c2.783,0.308,4.827,2.415,4.849,5.239c0.047,6.027,0.135,12.063-0.06,18.084c-0.241,7.532-6.534,13.861-14.072,14.291
		c-3.158,0.179-6.348,0.241-9.5,0.021c-5-0.35-8.901-2.898-11.77-6.912c-1.716-2.402-3.19-4.982-4.696-7.529
		c-2.286-3.867-4.508-7.774-6.748-11.669c-1.537-2.669-0.668-5.938,1.963-7.436c2.595-1.475,5.827-0.56,7.359,2.092
		c0.787,1.363,1.562,2.733,2.346,4.099c0.108,0.188,0.239,0.363,0.359,0.544C24.427,37.817,24.466,37.808,24.509,37.798z
		 M27.259,28.33c0,2.734,0,5.47,0,8.204c0,2.196,0.008,4.392-0.004,6.586c-0.008,1.022-0.809,1.731-1.689,1.429
		c-0.384-0.133-0.772-0.495-0.985-0.856c-1.776-3.013-3.511-6.05-5.263-9.078c-0.664-1.143-1.765-1.659-2.916-1.394
		c-1.805,0.415-2.579,2.329-1.601,4.025c2.723,4.738,5.462,9.471,8.197,14.202c1.325,2.299,2.674,4.585,4.562,6.486
		c2.617,2.638,5.756,4.047,9.513,4.008c2.278-0.024,4.557,0,6.837-0.005c6.731-0.017,12.374-5.385,12.514-12.113
		c0.123-5.839,0.03-11.684,0.028-17.525c0-0.724-0.277-1.34-0.799-1.828c-0.799-0.75-1.747-0.94-2.761-0.539
		c-1.097,0.433-1.64,1.305-1.661,2.468c-0.025,1.449-0.009,2.9-0.004,4.351c0.004,0.646-0.26,1.126-0.86,1.381
		c-0.957,0.401-1.885-0.303-1.893-1.441c-0.009-2.321,0-4.643-0.004-6.962c-0.002-1.672-1.1-2.846-2.632-2.831
		c-1.512,0.016-2.588,1.178-2.588,2.812c-0.008,2.301,0,4.601-0.005,6.899c0,0.995-0.564,1.636-1.398,1.619
		c-0.854-0.018-1.355-0.633-1.355-1.652c0.003-2.609,0.003-5.219,0-7.829c-0.001-1.663-1.108-2.84-2.643-2.827
		c-1.519,0.014-2.578,1.17-2.581,2.816c-0.003,2.651,0.006,5.305-0.005,7.955c-0.003,0.933-0.601,1.561-1.419,1.55
		c-0.786-0.009-1.321-0.628-1.336-1.556c-0.005-0.312-0.002-0.622-0.002-0.933c0-7.25,0.002-14.503-0.003-21.753
		c0-0.351-0.008-0.708-0.068-1.053c-0.239-1.353-1.585-2.286-2.94-2.062c-1.392,0.231-2.23,1.281-2.233,2.84
		C27.255,18.593,27.259,23.462,27.259,28.33z"
                />
                <path
                    fill="#FFFFFF"
                    d="M27.259,28.33c0-4.868-0.004-9.737,0.002-14.606c0.003-1.559,0.842-2.608,2.233-2.84
		c1.355-0.225,2.701,0.709,2.94,2.062c0.061,0.345,0.068,0.702,0.068,1.053c0.005,7.25,0.003,14.503,0.003,21.753
		c0,0.311-0.003,0.621,0.002,0.933c0.015,0.928,0.55,1.547,1.336,1.556c0.818,0.011,1.416-0.617,1.419-1.55
		c0.011-2.65,0.002-5.304,0.005-7.955c0.003-1.646,1.063-2.803,2.581-2.816c1.534-0.013,2.642,1.164,2.643,2.827
		c0.003,2.61,0.003,5.22,0,7.829c0,1.02,0.501,1.635,1.355,1.652c0.834,0.017,1.398-0.624,1.398-1.619
		c0.005-2.299-0.003-4.599,0.005-6.899c0-1.634,1.076-2.796,2.588-2.812c1.532-0.015,2.63,1.159,2.632,2.831
		c0.004,2.319-0.005,4.641,0.004,6.962c0.008,1.139,0.936,1.843,1.893,1.441c0.601-0.255,0.864-0.735,0.86-1.381
		c-0.005-1.45-0.021-2.901,0.004-4.351c0.021-1.163,0.564-2.035,1.661-2.468c1.014-0.401,1.962-0.211,2.761,0.539
		c0.521,0.488,0.799,1.104,0.799,1.828c0.002,5.842,0.095,11.687-0.028,17.525c-0.14,6.729-5.782,12.097-12.514,12.113
		c-2.28,0.005-4.559-0.02-6.837,0.005c-3.757,0.039-6.896-1.37-9.513-4.008c-1.888-1.901-3.236-4.188-4.562-6.486
		c-2.735-4.731-5.475-9.464-8.197-14.202c-0.979-1.696-0.204-3.61,1.601-4.025c1.151-0.266,2.252,0.251,2.916,1.394
		c1.752,3.028,3.486,6.065,5.263,9.078c0.213,0.361,0.602,0.724,0.985,0.856c0.881,0.303,1.682-0.406,1.689-1.429
		c0.012-2.194,0.004-4.39,0.004-6.586C27.259,33.8,27.259,31.064,27.259,28.33z"
                />
            </g>
        </svg>
    );
};

PointerCursorIcon.propTypes = {
    size: PropTypes.number
};

export default PointerCursorIcon;
